import React from 'react';
import { ChartWidget } from './ChartWidget';
import { TableWidget } from './TableWidget';
import { MetricWidget } from './MetricWidget';
import { WidgetConfig } from './widget';

interface WidgetRendererProps {
  widget: WidgetConfig;
  onEdit: (widget: WidgetConfig) => void;
  onRemove: (widgetId: string) => void;
  onSave?: (widget: WidgetConfig) => void;
  hasUnsavedChanges?: boolean;
  isEditing: boolean;
}

export const WidgetRenderer = ({
  widget,
  onEdit,
  onRemove,
  onSave,
  hasUnsavedChanges,
  isEditing,
}: WidgetRendererProps) => {
  const commonProps = { widget, onEdit, onRemove, onSave, hasUnsavedChanges, isEditing };

  if (widget.chartType === 'table') {
    return <TableWidget {...commonProps} />;
  }

  if (widget.chartType === 'metric') {
    return <MetricWidget {...commonProps} />;
  }

  return <ChartWidget {...commonProps} />;
};
